import ReactDOM from 'react-dom/client';
import App from './App';
import { initializeGA } from './utils/tracking';
import './global.less';
// import 'antd/dist/antd.css';

// 初始化 Google Analytics 4
initializeGA(import.meta.env.VITE_GA4_MEASUREMENT_ID);

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
    <App />,
  // </React.StrictMode>,
);
